import { Dispatch, SetStateAction } from "react";
import requiredDocuments from "../../../../../utils/requiredDocuments";
import { ConstantsResponseBoxDto } from "../../../../../components/cross/required-documentation/required-doc.dto";
import { Products } from "./required-documents-step.types";
import PayTypesServices from "../../../../../services/PayTypesServices";
import { ProductPayType } from "../../../../../services/PayTypesServices.dto";
import { SupplementDocument } from "../../../../../services/SupplementsServices.dto";
import { FormatedSupplementDoc } from "../../utils.type";

export const loadDocumentTypes = async (
  products_id: number,
  setDocumentTypes: Dispatch<SetStateAction<ConstantsResponseBoxDto[]>> |
  ((docs: ConstantsResponseBoxDto[]) => void)
) => {
  let result = await requiredDocuments.getDocumentTypes(() => {}, products_id);
  setDocumentTypes(result.documentTypes)
}

export const loadPayTypes = async (products_id: number, setPayType: Dispatch<SetStateAction<ProductPayType[]>>) => {
  let result = await PayTypesServices.getProductPayTypes({setLoading: () => {}, loader: false, productId: products_id});
  setPayType(result)
}

export const tableColumns = [
  "Tipo de documento",
  "Asegurado",
  "Opciones",
  "Tamaño *",
];

export const getType = (
  type: string | undefined,
  documentTypes: FormatedSupplementDoc[]
): string => {
  let elem = documentTypes.find((doc) => doc.value === type);
  if (elem) {
    return elem.label;
  }
  return "";
};

export const getFileSize = (size: number) => {
  if (size < 1024) {
    return `${size} bytes`;
  } else if (size >= 1024 && size < 1048576) {
    return `${(size / 1024).toFixed(1)} KB`;
  } else if (size >= 1048576) {
    return `${(size / 1048576).toFixed(1)} MB`;
  }
};

export const getProductIdFromCollective = (allProducts: Products, colectivo: string): number => {
  for (let productName in allProducts) {
    if (allProducts[productName].products_colectivo === colectivo) {
      return allProducts[productName].products_id;
    }
  }
  return 4;
};

export const getFormatedDocs = (docs: SupplementDocument[]): FormatedSupplementDoc[]  => {
  return docs.map((doc) => ({
    label: `${doc.code} - ${doc.description}`,
    value: doc.code,
    documentTypeMetadata: doc.documentType,
    required: doc.required,
  })).sort((docA, docB) => docA.label.localeCompare(docB.label));
};
